import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { ArrowLeft, Clock, Rocket } from 'lucide-react';

const ComingSoon = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Map paths to friendly titles
  const pageTitles = {
    '/pipeline/opportunities': 'Opportunities',
    '/pipeline/quotes': 'Quotes / Estimates',
    '/production/work-orders': 'Work Orders',
    '/production/qa': 'QA / Punch List',
    '/marketing/content': 'Content Queue',
    '/marketing/reviews': 'Reviews & Reputation',
  };

  const title = pageTitles[location.pathname] || 'Feature';

  return (
    <div className="min-h-[70vh] flex items-center justify-center p-6">
      <Card className="max-w-lg w-full text-center">
        <CardHeader className="pb-4">
          <div className="mx-auto w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-4">
            <Rocket className="h-8 w-8 text-primary" />
          </div>
          <CardTitle className="text-2xl">{title}</CardTitle>
          <CardDescription className="text-base">
            Coming Soon
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <p className="text-muted-foreground">
            We're working hard to bring you this feature. It will be available in an upcoming release.
          </p>
          
          <div className="flex items-center justify-center gap-2 text-sm text-muted-foreground">
            <Clock className="h-4 w-4" />
            <span>Expected in Phase 2</span>
          </div>

          <Button 
            variant="outline" 
            onClick={() => navigate(-1)}
            className="mt-4"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Go Back
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default ComingSoon;
